import { PiPencilSimpleLine, PiCalendarPlus, PiClockUser } from 'react-icons/pi'

import { EditCompanyModal } from 'components/Modals/CompanyModal/EditCompanyModal'
import { useState } from 'react'
import apiService from 'services/api'

import { formatDateWithTimeAndMinutes, formatDate2 } from 'utils/formatting'

interface CustomCompanySidebarFooterProps {
  chainProxyId: number
}

export function CustomCompanySidebarFooter({
  chainProxyId,
}: CustomCompanySidebarFooterProps) {
  const api = apiService()
  const { data: companyData } = api.useGetCompany(chainProxyId)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)

  return (
    <>
      <div className="w-full bg-gray-100 rounded-t-lg h-10 flex items-center justify-between text-gray-900 font-light text-xs px-2">
        <span className="inline-flex items-center justify-center gap-1">
          <PiCalendarPlus size={12} /> Created{' '}
          {formatDate2(companyData?.created)}
        </span>
        <span className="inline-flex items-center justify-center gap-1">
          <PiClockUser size={12} />
          Edited{' '}
          {formatDateWithTimeAndMinutes(new Date(companyData?.modified || ''))}
        </span>
      </div>

      <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 mt-auto flex justify-center">
        <EditCompanyModal
          show={isEditModalOpen}
          setShow={setIsEditModalOpen}
          company={companyData!}
          skipDealCreation={true}
        />
        <button
          className="flex items-center gap-1 text-brand-active hover:text-brand transition-colors bg-transparent border-none p-0 cursor-pointer"
          onClick={() => setIsEditModalOpen(true)}
        >
          <PiPencilSimpleLine size={16} />
          <span className="text-sm font-medium leading-[1.0431597573416573em]">
            Edit Company
          </span>
        </button>
      </div>
    </>
  )
}
